// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__7rA72","mobileMenuButton":"Menu_mobileMenuButton__qHYaJ","menu":"Menu_menu__uIEoR","active":"Menu_active__-0Z9R","mobileMenuActive":"Menu_mobileMenuActive__Rxi6T"};